import { render, staticRenderFns } from "./RegistrationV2.vue?vue&type=template&id=24eb88b9&scoped=true"
import script from "./RegistrationV2.vue?vue&type=script&lang=js"
export * from "./RegistrationV2.vue?vue&type=script&lang=js"
import style0 from "./RegistrationV2.vue?vue&type=style&index=0&id=24eb88b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24eb88b9",
  null
  
)

export default component.exports